<template>
  <main :class="this.class">
    <div class="main-visual">
			<div class="main-visual__body">
				<div class="main-visual__catch">
					<h2 class="main-visual__catch--white">
            <span class="main-visual__catch-item">DESIGN</span><br><span class="main-visual__catch-item">CREATION</span>
          </h2>
					<p class="main-visual__catch--black">
            <span v-for="(t, index) in catch1" :key="`first-${index}`" class="main-visual__catch-item">
              <span v-text="t"></span>
            </span>
            <br>
            <span v-for="(t, index) in catch2" :key="`second-${index}`" class="main-visual__catch-item">
              <span v-text="t"></span>
            </span></p>
				</div>
				<dl class="top-news" v-if="news_data">
					<dt class="top-news__ttl">NEWS</dt>
					<dd class="top-news__body">
						<router-link :to="{ name: 'NewsDetail', params: { newsId: news_data.id }}" class="top-news__link">
							<span class="top-news__date" v-if="news_data.date">{{ dateFormat(news_data.date) }}</span>
							<span class="top-news__body-ttl">{{ news_data.title }}</span>
							<span class="top-news__link-icon"></span>
						</router-link>
            <router-link to="/news" class="top-news__link-all">
              <span class="top-news__link-icon"></span>
            </router-link>
					</dd>
				</dl>
				<div class="main-visual__body-foot">
					<router-link to="/works" class="main-visual__btn">
						<img src="../assets/images/top/main-visual_btn.svg" alt="" />
					</router-link>
				</div>
			</div>
			<div class="main-visual__slide">
				<div class="main-visual__slide-bg"></div>
				<div class="main-visual__slide-image">
					<router-link :to="{ name: 'Detail', params: { workId: slide_url }}" id="js-slide" class="js-cursor-pt1"></router-link>
          <div v-for="(item, index) in  slide_src" :key="index" class="main-visual__slide-item">
            <img v-bind:src="item.src" alt="" class="main-visual__slide-item-image" />
          </div>
					<div class="main-visual__slide-progressbar" id="js-slide-progressbar"></div>
				</div>
				<div class="main-visual__slide-txt">
          <div v-for="(item, index) in slide_item" :key="index" :class="['main-visual__slide-txt__item js-slide-txt',activeClass(index)]">
            <router-link :to="{ name: 'Detail', params: { workId: item.id }}">
							<h3 class="main-visual__slide-ttl">{{ item.name }}</h3>
						</router-link>
						<p class="main-visual__slide-cat">{{ item.cat }}</p>
          </div>
				</div>
				<div class="main-visual__slide-nav">
					<button class="main-visual__slide-prev scene-nav scene-nav--prev" data-nav="previous">
						<svg viewBox="0 0 12.6 19.5" class="main-visual__slide-icon">
							<polygon points="9.8,19.5 0,9.8 9.8,0 12.6,2.8 5.7,9.8 12.6,16.7 " />
						</svg>
					</button>
					<button class="main-visual__slide-next scene-nav scene-nav--next" data-nav="next">
						<svg viewBox="0 0 12.6 19.5" class="main-visual__slide-icon">
							<polygon points="2.8,0 12.6,9.8 2.8,19.5 0,16.7 6.9,9.8 0,2.8 " />
						</svg>
					</button>
				</div>
			</div>
			<div class="main-visual__bg-txt">
        <div v-for="(item, index) in slide_item" :key="index" :class="['main-visual__bg-txt__item js-slide-bg-txt',activeClass(index)]">
          <span class="main-visual__bg-txt__marquee">{{ item.bgtxt }}</span>
          <span class="main-visual__bg-txt__marquee">{{ item.bgtxt }}</span>
        </div>
			</div>
		</div>
  </main>
</template>

<script>

//import store from '../store';

import * as PIXI from '../assets/js/lib/pixi.min.js'
import { TweenMax, TimelineMax, Power1, Power2 } from 'gsap'
import AssetsImage from "@/assets/images/top/clouds.jpg";

let stage  = new PIXI.Container();
let render = new PIXI.ticker.Ticker();
export default {
  name: 'home',
  title: '制作実績',
  data() {
    return {
      class: '',
      catch1: 'DESIGN',
      catch2: 'CREATION',
      slide_src: [],
      slide_url: null,
      slide_item: [],
      slideObj: null,
      news_data: []
    };
  },
  props: ['loading'],
  methods: {
    fadeIn: function () {
      this.class = '';
      setTimeout(() => {
           this.class = 'is-fadein';
      }, 10);
    },
    slide_url_set() {
      this.slide_url = this.slide_item[0].id;
    },
    async set_data() {
      let vm = this;
      const request = '/api/?type=home';
      vm.$axios.get(request, {
        timeout: 5000,
        responseType: 'json'
      })
      .then(function(response) {
        const slide_data = response.data;
        let item = [];
        //console.log('status:', response.status); // 200
        //console.log('body:', response.data); // response body.
        for (let i = 1; i < slide_data.length; i++) {
          item = {
            name: slide_data[i].site.title,
            cat: slide_data[i].site.category.english,
            bgtxt: slide_data[i].bgtxt,
            id: slide_data[i].site.id
          }
          vm.$data.slide_item.push(item);
          vm.$data.slide_src.push(slide_data[i].image.url);
        }
        let data = {
          id: slide_data[0].id,
          date: slide_data[0].date,
          title: slide_data[0].title
        }
        vm.$data.news_data = data;
        setTimeout(() => {
          vm.$emit('hover');
        }, 10);
        vm.slide_url_set();
        if (vm.loading) {
          setTimeout(() => {
            vm.slide();
          }, 1400);
        } else {
          vm.slide();
        }
      })
      .catch(function(error) {
        console.log(error);
      });
    },
    slide () {

      var self = this;

      var spriteImages = this.slide_src;
      var spriteImagesSrc = [];
      var texts = [];

      for (var i = 0; i < spriteImages.length; i++) {
        var img = spriteImages[i];
        spriteImagesSrc.push(img);
      }

      //  OPTIONS
      /// ---------------------------
      var sprites             = spriteImagesSrc;
      var stageWidth          = 1920;
      var stageHeight         = 1080;
      var pixiSprites         = sprites;
      var centerSprites       = true;
      var autoPlay            = false;
      var fullScreen          = true;
      var displaceScale       = [500, 500];
      var navElement          = document.querySelectorAll( '.scene-nav' );
      var displaceAutoFit     = false;
      var wacky               = true;
      var displaceScaleTo     = ( autoPlay === false ) ? [ 0, 0 ] : [ 20, 20 ];
      var textColor           = '#fff';
      var displacementCenter  = false;
      var progressbar         = document.getElementById('js-slide-progressbar');

      //  PIXI VARIABLES
      /// ---------------------------
      var renderer            = new PIXI.autoDetectRenderer( stageWidth, stageHeight, { transparent: true });
      stage               = new PIXI.Container();
      var slidesContainer     = new PIXI.Container();
      var displacementSprite  = new PIXI.Sprite.fromImage( AssetsImage );
      var displacementFilter  = new PIXI.filters.DisplacementFilter( displacementSprite );


      //  SLIDES ARRAY INDEX
      /// ---------------------------
      var currentIndex = 0;

      //  TEXTS
      /// ---------------------------
      var style = new PIXI.TextStyle({
        fill: textColor,
        wordWrap: true,
        wordWrapWidth: 400,
        fontSize: 36
      });

      /// ---------------------------
      //  INITIALISE PIXI
      /// ---------------------------
      function initPixi() {


        // Add canvas to the HTML
        document.getElementById('js-slide').appendChild( renderer.view );

        // Add child container to the main container
        stage.addChild( slidesContainer );


        // Enable Interactions
        stage.interactive = true;


        // Fit renderer to the screen
        if ( fullScreen === true ) {
          renderer.view.style.objectFit = 'cover';
          renderer.view.style.width     = '100%';
          renderer.view.style.height    = '100%';
          renderer.view.style.top       = '50%';
          renderer.view.style.left      = '50%';
          renderer.view.style.webkitTransform = 'translate( -50%, -50% ) scale(1.2)';
          renderer.view.style.transform = 'translate( -50%, -50% ) scale(1.2)';
        } else {
          renderer.view.style.maxWidth  = '100%';
          renderer.view.style.top       = '50%';
          renderer.view.style.left      = '50%';
          renderer.view.style.webkitTransform = 'translate( -50%, -50% )';
          renderer.view.style.transform = 'translate( -50%, -50% )';
        }

        displacementSprite.texture.baseTexture.wrapMode = PIXI.WRAP_MODES.REPEAT;

        // Set the filter to stage and set some default values for the animation
        stage.filters = [displacementFilter];

        if ( autoPlay === false ) {
          displacementFilter.scale.x = 0;
          displacementFilter.scale.y = 0;
        }

        if ( wacky === true ) {

          displacementSprite.anchor.set(0.5);
          displacementSprite.x = renderer.width / 2;
          displacementSprite.y = renderer.height / 2;
        }

        displacementSprite.scale.x = 2;
        displacementSprite.scale.y = 2;

        // PIXI tries to fit the filter bounding box to the renderer so we optionally bypass
        displacementFilter.autoFit = displaceAutoFit;
        stage.addChild( displacementSprite );
      }

      /// ---------------------------
      //  LOAD SLIDES TO CANVAS
      /// ---------------------------
      function loadPixiSprites( sprites ) {

        var rSprites = sprites;
        var rTexts   = texts;

        for ( var i = 0; i < rSprites.length; i++ ) {

          var texture   = new PIXI.Texture.fromImage( sprites[i] );
          var image     = new PIXI.Sprite( texture );

          if ( rTexts ) {
            var richText = new PIXI.Text( rTexts[i], style);
            image.addChild(richText);

            richText.anchor.set(0.5);
            richText.x = image.width / 2;
            richText.y = image.height / 2;
          }

          if ( centerSprites === true ) {
            image.anchor.set(0.5);
            image.x = renderer.width / 2;
            image.y = renderer.height / 2;
          }


            //image.transform.scale.x = 1.2;
            //image.transform.scale.y = 1.2;
          if ( i == 0  ) {
            TweenMax.set( image.scale, { x: 1.2, y: 1.2 } );
          }
          if ( i !== 0  ) {
            TweenMax.set( image, { alpha: 0 } );
          }

          slidesContainer.addChild( image );

        }
      }


      /// ---------------------------
      //  DEFAULT RENDER/ANIMATION
      /// ---------------------------

      render = new PIXI.ticker.Ticker();

      render.autoStart = true;

      render.add(function() {
        renderer.render( stage );
      });

      /// ---------------------------
      //  TRANSITION BETWEEN SLIDES
      /// ---------------------------
      var isPlaying = false;
      var slideImages = slidesContainer.children;
      var progressbarActive = function(){
        progressbar.classList.remove('is-active');
        setTimeout(function () {
          progressbar.classList.add('is-active');
        }, 100);
      }
      function moveSlider( newIndex ) {

        isPlaying = true;
        progressbarActive();



        var baseTimeline = new TimelineMax( { onComplete: function () {
          currentIndex = newIndex;
          isPlaying = false;
          if ( wacky === true ) {
            displacementSprite.scale.set( 1 );
          }
         },onUpdate: function() {

            if ( wacky === true ) {
              displacementSprite.rotation += baseTimeline.progress() * 0.02;
              displacementSprite.scale.set( baseTimeline.progress() * 9 ); //9
            }

        } });

        baseTimeline.clear();

        if ( baseTimeline.isActive() ) {
          return;
        }


        baseTimeline
        .to(displacementFilter.scale, 1, { x: displaceScale[0], y: displaceScale[1], ease: Power1.easeOut  })
        .to(slideImages[currentIndex], 0.5, { alpha: 0, ease: Power2.easeOut }, 0.2)
        .to(slideImages[newIndex], 0.5, { alpha: 1, ease: Power2.easeOut }, 0.3)
        .to(displacementFilter.scale, 1, { x: displaceScaleTo[0], y: displaceScaleTo[1], ease: Power2.easeOut }, 0.3 );

        TweenMax.fromTo(slideImages[newIndex].scale, 10, { x: 1.2 , y: 1.2 }, { x: 1 , y: 1, ease: Power2.easeOut });

        var textSlide = function(elm,index,link) {

          var eq = function(selector, index) {
            var nodeList = document.querySelectorAll(selector),
                length = nodeList.length;

            if (0 <= index && index < length) {
              return nodeList[index];
            }

            if (-1 <= length + index) {
              return nodeList[length + index];
            }

            return null;
          };
          var element = document.querySelectorAll(elm);
          var leaveLength = index < 1 ? element.length - 1 : newIndex - 1;
          var activeElement = eq(elm, index);
          var leaveElement = eq(elm, leaveLength);
          element.forEach(function (item) {
            item.classList.remove('is-active','is-leave');
          });
          if (link) {
            var linkElement = activeElement.getElementsByTagName("a");
            var href = linkElement[0].href;
            var url = href.split('/');
            var id = url.pop();
            self.slide_url = id;
          }
          activeElement.classList.add('is-active');
          leaveElement.classList.remove('is-active');
          leaveElement.classList.add('is-leave');
        }

        textSlide('.js-slide-txt', newIndex,true);
        textSlide('.js-slide-bg-txt', newIndex);
      }

      /// ---------------------------
      //  CLICK HANDLERS
      /// ---------------------------
      var nav = navElement;

      for ( var k = 0; k < nav.length; k++ ) {

        var navItem = nav[k];

        navItem.onclick = function() {

          slideStop(self);
          // Make sure the previous transition has ended
          if ( isPlaying ) {
            return false;
          }

          if ( this.getAttribute('data-nav') === 'next' ) {

            if ( currentIndex >= 0 && currentIndex < slideImages.length - 1 ) {
              moveSlider( currentIndex + 1 );
            } else {
              moveSlider( 0 );
            }

          } else {

            if ( currentIndex > 0 && currentIndex < slideImages.length ) {
              moveSlider( currentIndex - 1 );
            } else {
              moveSlider( spriteImages.length - 1 );
            }

          }
          slideStart(self);
          progressbar.classList.remove('is-active');
          return false;

        }

      }

      /// ---------------------------
      //  SLIDE AUTOPLAY
      /// ---------------------------
      //var timer;
      function slideStart(self) {
        TweenMax.fromTo(slideImages[0].scale, 10, { x: 1.2 , y: 1.2 }, { x: 1 , y: 1, ease: Power2.easeOut });

        progressbarActive();
        self.slideObj = setInterval(function(){
          if ( currentIndex >= 0 && currentIndex < slideImages.length - 1 ) {
            moveSlider( currentIndex + 1 );
          } else {
            moveSlider( 0 );
          }
        } , 6000);
      }
      function slideStop(self) {
        clearInterval(self.slideObj);
      }

      /// ---------------------------
      //  INIT FUNCTIONS
      /// ---------------------------
      function init(self) {
        initPixi();
        loadPixiSprites(pixiSprites);

        self.fadeIn();
        setTimeout(() => {
          document.getElementById('js-slide').parentNode.classList.add("is-start");
          slideStart(self);
        }, 1200);
      }

      /// ---------------------------
      //  CENTER DISPLACEMENT
      /// ---------------------------
      if ( displacementCenter === true ) {
        displacementSprite.anchor.set(0.5);
        displacementSprite.x = renderer.view.width / 2;
        displacementSprite.y = renderer.view.height / 2;
      }

      /// ---------------------------
      //  START
      /// ---------------------------
      init(self);
    },
    activeClass: function(index) {
      return (index == 0) ? ' is-active' : '';
    },
    dateFormat(date) {
      let newDate = new Date(date);
      newDate = newDate.getFullYear() + "." +  ("0" + (newDate.getMonth() + 1)).slice(-2) + "."+ ("0" + newDate.getDate()).slice(-2);
      return newDate;
    }
  },
  mounted() {
  },
  created: function() {
    this.$parent.footer = false;
    this.set_data();
  },
  beforeDestroy () {
    clearInterval(this.slideObj);
  },
  beforeRouteLeave (to, form, next) {
    stage.destroy();
    render.destroy();
    next();
	}
}
</script>
